// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_steel-shadow-light":"rgba(107, 128, 137, 0.2)","tile":"tile_tile__1DiaV","tileWithPadding":"tile_tileWithPadding__1O7Jf tile_tile__1DiaV"};